import axiosInstance from "../../utils/axios";

const Login = async (values) => {
  try {
    const response = await axiosInstance.post("/login", values);
    return { isStatus: true, data: response.data };
  } catch (err) {
    return {
      isStatus: false,
      data: null,
      message: err.response?.data?.message || err.message,
    };
  }
};

export default Login;
